import { Component, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';

import { AnnouncementService } from '../../../services/announcement.service';
import { CreateAnnouncement } from '../../../models/announcement';

@Component({
  selector: 'app-announcement-form',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './announcement-form.component.html',
  styleUrl: './announcement-form.component.scss'
})
export class AnnouncementFormComponent {
  announcementForm: FormGroup;
  isCreatingAnnouncement = false;
  createAnnouncementError = '';

  @Output() announcementCreated = new EventEmitter<void>();

  constructor(
    private fb: FormBuilder,
    private announcementService: AnnouncementService
  ) {
    this.announcementForm = this.fb.group({
      title: ['', [Validators.required, Validators.maxLength(50)]],
      image_url: ['', [Validators.required, Validators.pattern(/^https?:\/\/.+/)]],
      deeplink: ['', [Validators.required, Validators.pattern(/^https?:\/\/.+/)]],
    });
  }

  onSubmit(): void {
    if (this.announcementForm.invalid) {
      this.announcementForm.markAllAsTouched();
      return;
    }

    this.isCreatingAnnouncement = true;
    this.createAnnouncementError = '';

    const payload: CreateAnnouncement = this.announcementForm.value;

    this.announcementService.createAnnouncement(payload).subscribe({
      next: () => {
        this.isCreatingAnnouncement = false;
        this.announcementForm.reset();
        this.announcementCreated.emit();
      },
      error: (error) => {
        this.isCreatingAnnouncement = false;
        this.createAnnouncementError = error?.error?.detail || 'Não foi possível criar o anúncio.';
      },
    });
  }
}
